import React from 'react';
import {CommunitySettingsIcon} from "./icon";

export function CommunitySettingsItem({community_handle,theme}) {

    return <CommunitySettingsIcon community_handle={community_handle} theme={theme} />
}